import React from "react";
import { Button, Dialog, makeStyles, Typography } from "@material-ui/core";
import { borderRadiusValue } from "../../lib/constants";

const useStyles = makeStyles(
  () => ({
    root: {
      display: "flex"
    },
    paper: {
      backgroundColor: "#ffffff",
      borderRadius: borderRadiusValue,
      display: "flex",
      padding: "16px"
    },
    container: {
      width: "100%"
    },
    heading: {
      display: "flex",
      fontWeight: 500,
      userSelect: "none",
      width: "100%"
    },
    text: { display: "flex", userSelect: "none", width: "100%", whiteSpace: "pre-line" },
    closeButton: {
      marginTop: "10px"
    }
  }),
  {
    name: "MobileDialog"
  }
);

/**
 * @param {{ heading: string, onClose: () => void, open: boolean, text: string }} props
 */
export function MobileDialog(props) {
  const { heading, onClose, open, text } = props;
  const classes = useStyles();
  const close = React.useCallback(() => onClose(), [onClose]);
  return (
    <Dialog
      classes={{ root: classes.root, paper: classes.paper, container: classes.container }}
      open={open}
      onClose={close}
    >
      <Typography className={classes.heading} variant={"body1"}>
        {heading}
      </Typography>
      <Typography className={classes.text} color={"textSecondary"} variant={"body2"}>
        {text}
      </Typography>
      <Button className={classes.closeButton} onClick={onClose} color={"primary"} variant={"contained"}>
        Schließen
      </Button>
    </Dialog>
  );
}
